import { reactive } from 'vue'

export default reactive<any>({
  resources: {
    count: 0,
    items: [],
  },
  resource: null,
})
